// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc553270","393":"f5e3bf1a","447":"92e96510","455":"b55bf6d3","967":"c209c3a7","977":"1a5c6cb6"}[chunkId] + ".chunk.js";
};